import React, { memo, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { VariableSizeList } from "react-window";
import { findIndex } from "lodash";
import { makeStyles } from "@mui/styles";
import { POSTCODE_CARD } from "../../consts/sentryIds";
import { View } from "../View";
import ArtificialPostcodeCard from "./ArtificialPostcodeCard";
import {
  artificialPostcodeInEditSelector,
  selectedArtificialPostcodeSelector,
} from "../../reducers/depot/selectors";

const useStyles = makeStyles(({ typography }) => ({
  item: {
    marginTop: typography.pxToRem(2),
  },
  noScrollbar: {
    scrollbarWidth: "none",
    msOverflowStyle: "none",
    "&::-webkit-scrollbar": {
      display: "none",
    },
  },
}));

export const ArtificialPostcodeList = memo(({ height = 900, postcodes }) => {
  const listRef = useRef();
  const artificialPostcodeEdit = useSelector(artificialPostcodeInEditSelector);
  const selectedPostcode = useSelector(selectedArtificialPostcodeSelector);
  const styles = useStyles();

  useEffect(() => {
    if (!postcodes || (!artificialPostcodeEdit && !selectedPostcode)) return;
    listRef.current.resetAfterIndex(0, true);
    let selectedIndex = findIndex(
      postcodes,
      selectedPostcode
        ? ({ postcode }) => postcode === selectedPostcode.postcode
        : ({ postcode }) => postcode === artificialPostcodeEdit.postcode
    );
    if (selectedIndex < 0) return;
    listRef.current.scrollToItem(selectedIndex, "start");
  }, [postcodes, artificialPostcodeEdit, selectedPostcode]);

  const renderRow = ({ index, style }) => {
    const postcode = postcodes[index];
    const inEdit = artificialPostcodeEdit?.postcode === postcode.postcode;
    const selected = selectedPostcode?.postcode === postcode.postcode;
    return (
      <View
        className={styles.item}
        key={index}
        style={style}
        id={`postcode-card-${index}`}
        sentryId={`${POSTCODE_CARD}__${index}`}
      >
        <ArtificialPostcodeCard
          editMode={!!artificialPostcodeEdit}
          inEdit={inEdit}
          selected={selected}
          artificialPostcode={postcode}
        />
      </View>
    );
  };

  return (
    <>
      {Array.isArray(postcodes) && (
        <VariableSizeList
          className={styles.noScrollbar}
          ref={listRef}
          height={height}
          itemCount={postcodes.length}
          itemSize={() => 103}
          width={314}
        >
          {renderRow}
        </VariableSizeList>
      )}
    </>
  );
});
